import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ServiceSubscriberComponent} from './service-subscriber/service-subscriber.component';

const kServiceSubscriberEnabled = false;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, ServiceSubscriberComponent],
})
export class AppComponent {
    title = 'ngx-frog';
    public enableServiceSubscriber = kServiceSubscriberEnabled;
}
